import { Typography } from '@mui/material';

import { themeColors } from 'colors';

/** Small “settings” label; rendered in the top margin by {@link SettingsPageLayout}, or locally (e.g. AI Guardrails). */
const SettingsHeader = () => (
    <Typography variant="body1" whiteSpace="nowrap" width="100%" sx={{ color: themeColors.settingsPage.subheaderText }}>
        settings
    </Typography>
);

export default SettingsHeader;
